module.exports = __webpack_public_path__ + "static/media/united-kingdom.1e36085b.svg";